import http from 'hub-http/clients/apiClient';
export const fetchCalleeDetails = ({
  objectId,
  objectTypeId
}) => {
  const url = `/calls/v1/callees/omnibus/${objectTypeId}/${objectId}`;
  return http.get(url);
};